import type { Step } from 'react-joyride';

export const policyDetailTourSteps: Step[] = [
    {
        target: 'body',
        content:
            'ໜ້າລາຍລະອຽດນະໂຍບາຍ: ເບິ່ງຂໍ້ມູນ, ເນື້ອໃນ, ປະຫວັດສະບັບ ແລະ ການດຳເນີນການສຳຄັນ.',
        placement: 'center',
        disableBeacon: true,
    },
    {
        target: '[data-tourid="policy-detail-toolbar"]',
        content:
            'ສ່ວນຫົວໜ້າ: ປຸ່ມກັບຄືນ, ແກ້ໄຂ, ປະຫວັດສະບັບ, ແລະ ປຸ່ມເລີ່ມທົດສອບ.',
        placement: 'bottom',
    },
    {
        target: '[data-tourid="policy-detail-info"]',
        content:
            'ບັດຂໍ້ມູນຫຼັກຂອງນະໂຍບາຍ: ຫົວຂໍ້, ລະຫັດ, ສະຖານະ, ແລະ ວັນທີມີຜົນ.',
        placement: 'top',
    },
    {
        target: '[data-tourid="policy-detail-content"]',
        content: 'ເນື້ອໃນນະໂຍບາຍ ຫຼື ຂໍ້ມູນໄຟລ໌ແນບ.',
        placement: 'top',
    },
    {
        target: '[data-tourid="policy-detail-actions"]',
        content: 'ປຸ່ມການດຳເນີນການດ້ານລຸ່ມ ເຊັ່ນ ຍົກເລີກ ແລະ ເຜີຍແພ່.',
        placement: 'top',
    },
];
